

import React from "react";
import { Routes, Route } from "react-router-dom";
import StudentHome from "./pages/StudentHome";
import StudentChangePassword from "./pages/StudentChangePassword";
import StudentProfile from "./pages/StudentProfile";
import Jobs from "./pages/Jobs";
import JobApplicationForm from "./pages/JobApplicationForm";
import StuJobApplicationForm from "./pages/StuJobApplicationForm";
import JobStrategy from "./pages/JobStrategy";
import TrainingPrograms from "./pages/TrainingPrograms";
import ApplicationForm from "./pages/ApplicationForm";
import LiveEvents from "./pages/LiveEvents";
import StuLiveRegister from "./pages/StuLiveRegister";
import StudentJobApplyView from "./pages/Studentjobapplyview";


// import Jobsjobfairs from "./pages/Jobsjobfairs";

import JobView from "./pages/JobView";
import Jobfairs from "./pages/Jobfairs";
import Jobfairregister from "./pages/Jobfairregister";



function StudentDashboardRoutes() {
  return (
    <Routes>
      <Route path="/" element={<StudentHome />} />
      <Route path="/StudentChangePassword" element={<StudentChangePassword />} />
      <Route path="/StudentProfile" element={<StudentProfile />} />
      <Route path="/Jobs" element={<Jobs/>} />
      <Route path="/jobs/:jobId" element={<JobView />} />
      <Route path="/LiveJobs/:jobId" element={<StuJobApplicationForm />} />
      <Route path="/JobApplicationForm" element={<JobApplicationForm />} />
      <Route path="/JobStrategy" element={<JobStrategy />} />
      <Route path="/TrainingPrograms" element={<TrainingPrograms />} />
      <Route path="/ApplicationForm" element={<ApplicationForm />} />
      <Route path="/LiveEvents" element={<LiveEvents />} />
      <Route path="/StuLiveRegister" element={<StuLiveRegister />} />
      <Route  path="/Jobapply/:jobId" element={<StudentJobApplyView/>} />
      


      {/* <Route path="/Jobsjobfairs" element={<Jobsjobfairs/>}/> */}

      <Route path="/Jobfairs" element={<Jobfairs />} />
      <Route path="/Jobfairregister" element={<Jobfairregister />} />


    </Routes>

  );
}

export default StudentDashboardRoutes;
